import { mystParse } from "myst-parser";

export function parse(mystText: string): any {
  return mystParse(mystText);
}
